import '@/styling/main.less';
import { createApp } from 'vue';

// Own config
import '@/core/config/breakpointConfig';

// error handling as first
import errorHandling from '@/core/errorHandling';

// 3rd party
import icons from '@/core/config/svg-icons.plugin';

// Various areas
import formConfig from '@/core/form';
import responsive from '@/core/responsive';
import translation from '@/core/translation';
import filters from '@/core/filters';
import autofocusDirective from '@/core/dom/autofocus.directive';
import delegateHTMLLinksDirective from '@/core/dom/delegateHtmlLinks.directive';
import auth from '@/project/auth/';

// All other core component registrations
import componentRegistration from '@/core/config/coreComponentRegistrations';
import '@/core/ui-components/swiper';
import clickOutside from '@/project/config/v-click-outside.plugin';
import tooltip from '@/project/config/v-tooltip.plugin';
import InputText from '@/project/form/InputText.vue';
import InputTextArea from '@/project/form/InputTextArea.vue';

import { router, initRouter } from '@/router';
import { productguideRoutes } from '@/entry-points/productguide/router/productguide.routes.constants';
import AccessibilityPlugin from '@/core/accessibility';
import CallToAction from '@/project/form/CallToAction.vue';
import ProductTile from '@/project/product/product-tile/ProductTile.vue';
import ProductGuideAppIndex from '@/entry-points/productguide/ProductGuideAppIndex.vue';


const app = createApp(ProductGuideAppIndex);
initRouter(productguideRoutes);

errorHandling(app);
icons(app);
formConfig(app);
responsive(app);
translation(app);
filters(app);
autofocusDirective(app);
delegateHTMLLinksDirective(app);
componentRegistration(app);
clickOutside(app);
tooltip(app);
auth(app);
app.component('ProductTile', ProductTile);
app.component('CallToAction', CallToAction);
app.component('InputText', InputText);
app.component('InputTextArea', InputTextArea);
AccessibilityPlugin(app);
app.use(router);
router.isReady().then(() => app.mount('#app'));

